/* eslint-disable max-len */
import React, {useCallback} from 'react';
import {maxSizeEachFileInMegaBytes} from '../../../../common/constants/ftr';
import {Card} from 'semantic-ui-react';
import {connect} from 'react-redux';
import './styles.scss';
import {Actions} from '../../../../common/actions';
import {useDropzone} from 'react-dropzone';

const maxSizeEachFileInBytes = maxSizeEachFileInMegaBytes * 1000 * 1024;

const HandleFiles = ({
  attachment,
  setAttachment,
  disabled,
}) => {
  const onDrop = useCallback((fileItems) => {
    setAttachment((attachment) => [...(attachment || []), ...fileItems]);
  });

  const removeItem = (data, index) => {
    if (index === 0) {
      return [...data.slice(1)];
    } else if (index) {
      return [...data.slice(0, index), ...data.slice(index + 1)];
    }
    return [];
  };

  const onDeleteFile = (index = null) => {
    setAttachment(removeItem(attachment, index));
  };

  const onDownloadFile = (index = null) => {
    const file = index !== null && attachment[index];
    const filename = file.name;
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const {
    fileRejections,
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop,
    'accept': {
      'application/pdf': [],
    },
    'maxSize': maxSizeEachFileInBytes,
  });
  return (
    <Card raised fluid>
      <Card.Content>
        {(attachment?.length) ?
          <>
            {attachment.map((rawAttachment, index) =>
              <div className='floating-inv-container-download' key={index}>
                <span>
                  {rawAttachment?.name || 'ARCHIVO'}
                </span>
                <div>
                  <span className='link' onClick={() => onDownloadFile(index)}>
                    {'DESCARGAR'}
                  </span>
                  {
                    !disabled && (
                      <span className='floating-inv-delete-file' onClick={() => onDeleteFile(index)}>
                        {'ELIMINAR'}
                      </span>
                    )
                  }
                </div>
              </div>
            )}
          </> : <p className='not-found-files-upload'>No existen archivos adjuntos.</p>
        }
        {
          !disabled && (
            <section className="container">
              <div {...getRootProps({'className': 'dropzone-container'})}>
                <input {...getInputProps()} />
                <p>Arrastre aquí el archivo o súbalo <em>haciendo click sobre este texto.</em> </p>
                {fileRejections.length > 0 &&
                  <em className='warning-message'>
                    Archivo no aceptado, verifique que sea un archivo PDF con un tamaño máximo de {maxSizeEachFileInMegaBytes} MB.
                  </em>}
              </div>
            </section>
          )
        }
      </Card.Content>
    </Card>
  );
};

const {
  setFlRawInventoryAttachments,
} = Actions;

export default connect(null, {setFlRawInventoryAttachments})(
  HandleFiles
);
